import { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

import Container from "react-bootstrap/Container";

import IconButton from "../Components/IconButton";
import HelmetComponent from "../Components/HelmetComponent";
import PageSwiper from "../Components/PageSwiper";
import Testimonial_Detail from "../Components/Testimonial_Detail";
import VacanciesSwiper from "../Components/VacanciesSwiper";

import Footer from "../Components/Footer";

import { createMarkup, idFromText } from "../Helpers/htmlHelper";
import useSwiperNavigation from "../Helpers/useSwiperNavigation";
import { mapSlideIdsToIndices, viewSlideById, viewSlideByIndex } from "../Helpers/DOM";

import Careers_Stories_1 from "../../assets/images/careers_stories_1.webp";
import Careers_Stories_2 from "../../assets/images/careers_stories_2.webp";
import Careers_Stories_3 from "../../assets/images/careers_stories_3.webp";
import Careers_Stories_4 from "../../assets/images/careers_stories_4.webp";
import Careers_Stories_6 from "../../assets/images/careers_stories_5.webp";
import Careers_Stories_5 from "../../assets/images/careers_stories_6.webp";

import { useTranslation } from "react-i18next";

const testimonials = [
  {
    storyNumber: 1,
    image: Careers_Stories_1,
    backdropColor: "lime",
  },
  {
    storyNumber: 2,
    image: Careers_Stories_2,
    backdropColor: "primary-blue",
  },
  {
    storyNumber: 3,
    image: Careers_Stories_3,
    backdropColor: "yorange",
  },
  {
    storyNumber: 4,
    image: Careers_Stories_4,
    backdropColor: "lime",
  },
  {
    storyNumber: 5,
    image: Careers_Stories_5,
    backdropColor: "primary-blue",
  },
  {
    storyNumber: 6,
    image: Careers_Stories_6,
    backdropColor: "yorange",
  },
];

const Testimonials = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const testimonialPaths = testimonials.map(({ storyNumber }) => `/careers/testimonials/${idFromText(t(`careers_story_${storyNumber}_name`))}`);

  const pageSwiperInstance = useRef(null);
  useSwiperNavigation(pageSwiperInstance, {
    skipScrollOnPaths: testimonialPaths,
  });

  const refreshPageSwiper = () => {
    if (pageSwiperInstance.current) {
      pageSwiperInstance.current.update();
    }
  };

  const [idToIndexMap, setIdToIndexMap] = useState({});

  const _viewSlideById = (id) => {
    viewSlideById(pageSwiperInstance, idToIndexMap, id);
  };

  useEffect(() => {
    const map = mapSlideIdsToIndices();
    setIdToIndexMap(map);
  }, []);

  useEffect(() => {
    if (!id || Object.keys(idToIndexMap).length === 0) return;

    // Scroll to the correct slide if the ID matches
    if (idToIndexMap[id]) {
      viewSlideById(pageSwiperInstance, idToIndexMap, id);
    }
  }, [id, idToIndexMap]);

  return (
    <>
      <HelmetComponent page={"testimonials"} />
      <PageSwiper className="career-detail-section-swiper" setSwiperInstance={(swiper) => (pageSwiperInstance.current = swiper)}>
        {/* Introduction Section */}
        <div className="swiper-slide bg-primary-blue">
          <Container className={"py-mts_3_125 px-4 py-md-mts_4_125 px-md-mts_8_25 text-white text-center"}>
            <h1 dangerouslySetInnerHTML={createMarkup(t("careers_testimonials_header_title"))}></h1>
            <p className="my-3 mt-md-3 mb-md-0 align-self-stretch">{t("careers_testimonials_header_description")}</p>
          </Container>
        </div>

        {testimonials.map(({ storyNumber, image, backdropColor }) => {
          return (
            <div
              key={idFromText(t(`careers_story_${storyNumber}_name`))}
              id={idFromText(t(`careers_story_${storyNumber}_name`))}
              className={`swiper-slide enable-freemode`}
              // className={`swiper-slide enable-freemode bg-${storyNumber % 2 !== 0 ? "blue-25" : "blue-50"}`}
            >
              <Testimonial_Detail
                id={id}
                storyNumber={storyNumber}
                image={image}
                backdropColor={backdropColor}
                onToTopClick={() => _viewSlideById(idFromText(t(`careers_story_1_name`)))}
              />
            </div>
          );
        })}

        {/* Vacancies */}
        <div id="vacancies" className={`swiper-slide bg-blue-25`}>
          <Container className={"py-mts_2_5 py-md-mts_4_125"}>
            <div className="text-center text-md-start">
              <span className="text-primary-dark-blue section_header text-uppercase">{t("home_careers_main")}</span>
              <div className="hstack">
                <h2 className="text-primary-dark-blue mx-auto me-md-auto ms-md-0">{t("home_careers_title")}</h2>
                <Link to={`https://career.ame.nu/`} target="_blank" className="d-none d-md-block">
                  <IconButton variant="link" iconAfter="arrow-right" size="sm" className="text-primary-dark-blue">
                    {t("home_careers_vacancies_CTA")}
                  </IconButton>
                </Link>
              </div>
            </div>

            <VacanciesSwiper onDataLoad={refreshPageSwiper} />
          </Container>
        </div>
        <div className="swiper-slide bg-primary-dark-blue">
          <Footer></Footer>
        </div>
      </PageSwiper>
    </>
  );
};

export default Testimonials;
